// Kept in their own .ts file, not NetworkMap.tsx — a plain non-component
// export from a .tsx file breaks Fast Refresh for that whole file.

import type { Point, SwmmProject } from "./types.ts";

export interface Bounds {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
}

function extendBounds(bounds: Bounds, point: Point): Bounds {
  return {
    minX: Math.min(bounds.minX, point.x),
    minY: Math.min(bounds.minY, point.y),
    maxX: Math.max(bounds.maxX, point.x),
    maxY: Math.max(bounds.maxY, point.y),
  };
}

export function computeBounds(project: SwmmProject): Bounds | null {
  let bounds: Bounds | null = null;
  const extend = (point: Point) => {
    bounds = bounds
      ? extendBounds(bounds, point)
      : { minX: point.x, minY: point.y, maxX: point.x, maxY: point.y };
  };
  for (const point of project.coordinates.values()) extend(point);
  for (const points of project.vertices.values()) points.forEach(extend);
  for (const points of project.polygons.values()) points.forEach(extend);
  for (const point of project.symbols.values()) extend(point);
  return bounds;
}

/** A polygon's own vertex average — not a true area centroid, which no caller here needs. */
export function polygonCentroid(points: Point[]): Point {
  const sum = points.reduce((acc, p) => ({ x: acc.x + p.x, y: acc.y + p.y }), { x: 0, y: 0 });
  return { x: sum.x / points.length, y: sum.y / points.length };
}
